import { j as jsxRuntimeExports } from "../../../jsx-runtime-9d42c573.js";
import { useMemo } from "react";
import { TYPE_UNDEFINED } from "../constants/constants.js";
import { useLoadImage } from "../hooks/useLoadImage.js";
import { twMerge } from "tailwind-merge";
import BgImage$1 from "./basic-bg-image.js";
import "goober";
const BgImage = ({
  url,
  urlSet,
  className = "",
  style = {},
  width,
  height,
  onLoad,
  onError,
  ...rest
}) => {
  const _url = useMemo(() => {
    if (typeof window === TYPE_UNDEFINED)
      return void 0;
    const _index = Math.max(Math.min(Math.ceil(window.devicePixelRatio ?? 2), 3) - 1, 0);
    return urlSet == null ? void 0 : urlSet[_index];
  }, [urlSet]);
  useLoadImage({ src: _url || "", onLoad, onError });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    BgImage$1,
    {
      className: twMerge("bg-cover bg-center bg-no-repeat h-full bg-white", className),
      url,
      url_set: urlSet,
      ...rest,
      style: {
        width,
        height,
        ...style
      }
    }
  );
};
export {
  BgImage as default
};
//# sourceMappingURL=bg-image.js.map
